import { useEffect } from 'react';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

const STAGGER_MS = 60;

/**
 * `.reveal` 요소를 뷰포트 진입 시 순차 등장시킨다.
 *
 * 라우트가 바뀔 때마다 다시 훑어야 하므로 페이지 컴포넌트에서 호출한다.
 * `deps` 에 라우트 키를 넘기면 그 시점에 재관찰한다.
 */
export function useScrollReveal(deps = []) {
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const targets = Array.from(document.querySelectorAll('.reveal'));
    if (!targets.length) return undefined;

    if (prefersReducedMotion) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        // 같이 나타나는 것들끼리만 60ms 씩 밀어 순차 등장시킨다.
        // forEach 의 index 를 쓰면 화면 밖으로 나가는(교차 해제) 항목까지 세어
        // 실제로는 하나만 등장하는데 300ms 씩 지연되는 일이 생긴다
        let appearing = 0;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.transitionDelay = `${appearing * STAGGER_MS}ms`;
          appearing += 1;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 },
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefersReducedMotion, ...deps]);
}
